import React, { useState } from 'react'
import './ProductInfoComponent.css'
import ProductSpecification from './ProductSpecification/ProductSpecification'
import PriceComponent from './PriceComponent/PriceComponent'
import EstimateDeliveryComponent from './EstimateDeliveryComponent/EstimateDeliveryComponent'
import parse from "html-react-parser";

const ProductInfoComponent = ({product}) => {
    const [combination, setCombination] = useState({});
    const [error, setError] = useState();
    return (
        <section className='ProductInfoComponent'>
            <div className='product_info_text_sec'>

                <div className='product_heading_main_div'>

                    <div className='product_heading_div'>
                        <div className='title_div'>
                            <p className='title'>{product?.name}</p>
                        </div>
                        <div className='offer_div'>
                            <p className='offer_text'>Buy in bulk and save</p>
                        </div>
                    </div>

                    <div className='subinfo_div'>
                        <p className='subinfo'>{product?.sub_title}</p>
                    </div>
                    
                </div>

                <div className='product_features_div'>

                    <p className='feature_title'>{parse(String(product?.description || ""))}</p>
                    {/* <p className='feature_descn'>Explore 4000+ design options to find the perfect match for your needs.</p>

                    <p className='feature_title'>Premium Paper Choices:</p>
                    <p className='feature_descn'>Standard glossy or matte paper is included at no extra cost.</p>

                    <p className='feature_title'>Final Dimensions:</p>
                    <p className='feature_descn'>The finished card size will be 8.9 cm x 5.1 cm. Dimensions shown on the design page include the bleed area.</p>

                    <p className='feature_title'>Bleed and Safety Area:</p>
                    <p className='feature_descn'>- Extend your design to the bleed area to prevent white borders from appearing around the edges.</p>
                    <p className='feature_descn'>- Ensure all important information stays within the safety area for a clean, professional look.</p> */}

                    <p className='warning_text'>
                        [We do not accept designs that belong to or represent government or government-affiliated organizations]
                    </p>
                </div>

                <div className='product_specification_main_div'>
                    <ProductSpecification error={error} setError={setError}setCombination={setCombination} combination={combination}product={product}/>
                </div>

                <div className='price_component_main_div'>
                    <PriceComponent error={error} combination={combination} product={product}/>
                </div>

                <div className='estimate_delivery_main_div'>
                    <EstimateDeliveryComponent combination={combination}  product={product}/>
                </div>


            </div>
        </section>
    )
}

export default ProductInfoComponent
